import { useState, useEffect } from 'react';

const SCREEN_SIZES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
  LARGE_DESKTOP: 'largeDesktop'
};

const BREAKPOINTS = {
  MOBILE: 425,
  TABLET: 769,
  DESKTOP: 1440
};

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    type: getScreenType(window.innerWidth)
  });

  function getScreenType(width) {
    if (width >= BREAKPOINTS.DESKTOP) {
      return SCREEN_SIZES.LARGE_DESKTOP;
    } else if (width >= BREAKPOINTS.TABLET) {
      return SCREEN_SIZES.DESKTOP;
    } else if (width >= BREAKPOINTS.MOBILE) {
      return SCREEN_SIZES.TABLET;
    } else {
      return SCREEN_SIZES.MOBILE;
    }
  }

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        width,
        type: getScreenType(width)
      });
    };

    window.addEventListener('resize', handleResize);
    
    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    width: screenSize.width,
    type: screenSize.type,
    isMobile: screenSize.type === SCREEN_SIZES.MOBILE,
    isTablet: screenSize.type === SCREEN_SIZES.TABLET,
    isDesktop: screenSize.type === SCREEN_SIZES.DESKTOP,
    isLargeDesktop: screenSize.type === SCREEN_SIZES.LARGE_DESKTOP
  };
};

export default useScreenSize; 